import { render, staticRenderFns } from "./CountupComponent.vue?vue&type=template&id=9b3e477e"
import script from "./CountupComponent.vue?vue&type=script&lang=js"
export * from "./CountupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports